import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authSessionStoreFactory } from '@area-restrita/client/authentication';

const authSessionStore = authSessionStoreFactory({});

export const useAuthSessionStore = create(
  persist(authSessionStore, {
    name: 'session',
  }),
);
